import { AnyAction } from 'redux'
import { Region } from '@babylon/consumer-api/types'

import { SET_REGION_INFO } from './constants'

export default (state: Region = {}, { type, payload }: AnyAction) => {
  switch (type) {
    case SET_REGION_INFO:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}
